import MetadataPlugin from './MetadataPlugin';

export * from './Metadata';
export default MetadataPlugin;
